import * as Yup from 'yup';

export const formSchema = Yup.object({
    title : Yup.string().required("Please enter title to your post").min(8),
    message : Yup.string().required().min(9),
    stream : Yup.string().required("Enter valid credential according to example").min(5).max(10),
});
